import { render, staticRenderFns } from "./CreateEmployeesRoute.vue?vue&type=template&id=6460e8e3&scoped=true&"
import script from "./CreateEmployeesRoute.vue?vue&type=script&lang=js&"
export * from "./CreateEmployeesRoute.vue?vue&type=script&lang=js&"
import style0 from "./CreateEmployeesRoute.vue?vue&type=style&index=0&id=6460e8e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6460e8e3",
  null
  
)

export default component.exports